import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import Collapse from '@material-ui/core/Collapse'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'
import { formatDateAndTime } from '../../utils/dashboard.utils'

const styles = (theme) => ({
  root: {
    boxShadow: 'none',
    backgroundColor: 'transparent'
  },

  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: 'rotate(90deg)'
  },
  tablecell1: {
    fontWeight: 'normal',
    fontSize: '13px',
    color: 'black',
    margin: '0 10px'
  },
  card: {
    padding: '12px 0',
    fontSize: 13
  }
})

const ReleaseInfoMobileComponent = ({
  classes,
  releaseInfoSearchRows,
  selected
}) => {
  return (
    <div className={classes.root}>
      {createReleaseInfoRow(releaseInfoSearchRows, selected, classes)}
    </div>
  )
}

const createReleaseInfoRow = (releaseInfoSearchRows, selected, classes) => {
  return releaseInfoSearchRows
    .slice(selected * 10, selected * 10 + 10)
    .map((el, index) => {
      const [expanded, setExpanded] = React.useState(false)
      return (
        <div
          key={el.update_id}
          style={
            index % 2 ? { background: 'white' } : { background: '#ebf9fa' }
          }
        >
          <Card
            onClick={() => {
              setExpanded(!expanded)
            }}
            aria-expanded={expanded}
            aria-label="show more"
            classes={{
              root: classes.root
            }}
          >
            <CardActions className={classes.card}>
              <div style={{ display: 'flex' }}>
                <div className={classes.tablecell1}>
                  {formatDateAndTime(el.created)}
                </div>
                <div className={classes.tablecell1}>
                  {expanded ? ' ' : el.newsupdate.slice(0, 20) + '...'}
                </div>
              </div>
              <KeyboardArrowRightIcon
                className={clsx(classes.expand, {
                  [classes.expandOpen]: expanded
                })}
              />
            </CardActions>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
              <CardContent>
                <span className={classes.card}>{el.newsupdate}</span>
              </CardContent>
            </Collapse>
          </Card>
        </div>
      )
    })
}

export default withStyles(styles)(ReleaseInfoMobileComponent)
